import React, { FC } from 'react'
import { system as s } from '@moonpig/launchpad-system'
import { styled, breakpoint } from '@moonpig/launchpad-utils'
import { Container } from '@moonpig/launchpad-components'

import { NAV_BP } from '../constants'

const StyledHeaderWrapper = styled.div`
  ${s({
    bgcolor: 'colorBackground01',
    borderBottom: 2,
    borderColor: 'colorBorder03',
  })}

  ${breakpoint('md')} {
    ${s({ marginBottom: 11 })}
  }
`

const StyledHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: 48px;
  ${breakpoint(NAV_BP)} {
    height: 96px;
  }
`

type AuthHeaderProps = {
  logoLink: React.ReactNode
}

export const AuthHeader: FC<React.PropsWithChildren<AuthHeaderProps>> = ({
  logoLink,
}) => {
  return (
    <StyledHeaderWrapper>
      <Container limitWidth>
        <StyledHeader>{logoLink}</StyledHeader>
      </Container>
    </StyledHeaderWrapper>
  )
}
